import { SarlaftFormProps } from './props';
import { useSarlaftForm } from './hooks';
import FormView from '../../../../components/views/formView';
import LoadingButtonGeneral from '../../../../components/general/buttons/loadingButtonGeneral';
import { Grid } from '@mui/material';
import { SarlaftCallInfo } from './callInfo';
import { SarlaftTypification } from './typification';
import { SarlaftSecurity } from './security';
import SearchIcon from '@mui/icons-material/Search';
import { SarlaftVinculation } from './vinculation';
import { SarlaftVinculationExist } from './vinculationExist';
import { SarlaftPersonNatural } from './personNatural';
import { SarlaftTypePerson } from './typePerson';
import { SarlaftSurvey } from './survey';
import { SarlaftFinancial } from './financial';
import { SarlaftOperations } from './operations';
import { SarlaftInsurance } from './informationInsurace';
import { SarlaftClaims } from './claims';
import { SarlaftForms } from './forms';
import { SarlaftDeclaration } from './declaration';
import { SarlaftStrategicAlly } from './strategicAlly';
import { SarlaftOperationInternational } from './operationInternational';
import { SarlaftStateCase } from './stateCase';
import { SarlaftSendMail } from './sendMail';

export const SarlaftForm = ({ showFormView, account }: SarlaftFormProps) => {
    const {
        sarlaft,
        formikSarlaftSecurity,
        formikSarlaftOperationInternational,
        formikSarlaftInsurance,
        isSuccessfulValidation,
        loading,
        handleSubmit,
        handleClean,
        handleBack,
        setFormikSarlaftCallInfo,
        setFormikSarlaftSecurity,
        setFormikSarlaftTypification,
        setFormikSarlaftVinculation,
        setFormikSarlaftVinculationExist,
        setFormikSarlaftTypePerson,
        setFormikSarlaftPersonNatural,
        setFormikSarlaftSurvey,
        setFormikSarlaftFinancial,
        setFormikSarlaftOperationInternational,
        setFormikSarlaftOperations,
        setFormikSarlaftInsurance,
        setFormikSarlaftComplaints,
        setFormikSarlaftForm,
        setFormikSarlaftDeclaration,
        setFormikSarlaftStateCase,
        setFormikSarlaftSendEmail,
        setFormikSarlaftStrategicAlly,
    } = useSarlaftForm(account);

    return (
        <>
            {showFormView && (
                <FormView
                    title={
                        sarlaft && sarlaft.id
                            ? 'Editar SARLAFT'
                            : 'Crear SARLAFT'
                    }
                    onClickBack={handleBack}
                    labelBack="Buscar"
                    iconBack={<SearchIcon />}
                    variantBack="outlined"
                />
            )}
            <SarlaftCallInfo
                data={sarlaft?.callInfo}
                onChangeFormik={(formik) => setFormikSarlaftCallInfo(formik)}
            />
            <SarlaftSecurity
                data={sarlaft?.security}
                onChangeFormik={(formik) => setFormikSarlaftSecurity(formik)}
                isSuccessfulValidation={isSuccessfulValidation}
                account={account}
            />
            {isSuccessfulValidation && (
                <>
                    <SarlaftVinculation
                        data={sarlaft?.entailment}
                        onChangeFormik={(formik) =>
                            setFormikSarlaftVinculation(formik)
                        }
                    />
                    <SarlaftVinculationExist
                        data={sarlaft?.existingEntailment}
                        onChangeFormik={(formik) =>
                            setFormikSarlaftVinculationExist(formik)
                        }
                    />
                    <SarlaftTypePerson
                        data={sarlaft?.typePerson}
                        onChangeFormik={(formik) =>
                            setFormikSarlaftTypePerson(formik)
                        }
                    />
                    <SarlaftPersonNatural
                        data={sarlaft?.naturalPerson}
                        ageClient={formikSarlaftSecurity?.values.ageClient}
                        onChangeFormik={(formik) =>
                            setFormikSarlaftPersonNatural(formik)
                        }
                    />
                    <SarlaftSurvey
                        data={sarlaft?.survey}
                        onChangeFormik={(formik) =>
                            setFormikSarlaftSurvey(formik)
                        }
                    />
                    <SarlaftFinancial
                        data={sarlaft?.financialInformation}
                        onChangeFormik={(formik) =>
                            setFormikSarlaftFinancial(formik)
                        }
                    />
                    <SarlaftOperationInternational
                        data={sarlaft?.internationalOperationsActivities}
                        onChangeFormik={(formik) =>
                            setFormikSarlaftOperationInternational(formik)
                        }
                    />
                    {formikSarlaftOperationInternational?.values
                        .foreignCurrencyAccounts && (
                        <SarlaftOperations
                            data={sarlaft?.operations}
                            onChangeFormik={(formik) =>
                                setFormikSarlaftOperations(formik)
                            }
                        />
                    )}
                    <SarlaftInsurance
                        data={sarlaft?.insurance}
                        onChangeFormik={(formik) =>
                            setFormikSarlaftInsurance(formik)
                        }
                    />
                    {formikSarlaftInsurance?.values.complaintsLastTwoYears && (
                        <SarlaftClaims
                            data={sarlaft?.complaints}
                            onChangeFormik={(formik) =>
                                setFormikSarlaftComplaints(formik)
                            }
                        />
                    )}
                    <Grid
                        container
                        spacing={{ xs: 1.5, md: 1.5 }}
                        columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
                        pt="20px"
                    >
                        <SarlaftForms
                            data={sarlaft?.form}
                            onChangeFormik={(formik) =>
                                setFormikSarlaftForm(formik)
                            }
                        />
                        <SarlaftDeclaration
                            data={sarlaft?.taxReturn}
                            onChangeFormik={(formik) =>
                                setFormikSarlaftDeclaration(formik)
                            }
                        />
                        <SarlaftStateCase
                            data={sarlaft?.caseStatus}
                            onChangeFormik={(formik) =>
                                setFormikSarlaftStateCase(formik)
                            }
                        />
                    </Grid>
                    <SarlaftStrategicAlly
                        data={sarlaft?.strategicAlly}
                        onChangeFormik={(formik) =>
                            setFormikSarlaftStrategicAlly(formik)
                        }
                    />
                    <SarlaftSendMail
                        data={sarlaft?.intermediateForm}
                        onChangeFormik={(formik) =>
                            setFormikSarlaftSendEmail(formik)
                        }
                    />
                </>
            )}
            <SarlaftTypification
                data={sarlaft?.typification}
                onChangeFormik={(formik) =>
                    setFormikSarlaftTypification(formik)
                }
            />
            <Grid item xs={12} mt={5} mb={10}>
                <LoadingButtonGeneral
                    disabled={loading}
                    loading={loading}
                    title="Guardar"
                    sx={{ mr: 1 }}
                    onClick={handleSubmit}
                />
                {(!sarlaft || !sarlaft.id) && (
                    <LoadingButtonGeneral
                        disabled={loading}
                        title="Limpiar"
                        variant="outlined"
                        onClick={handleClean}
                    />
                )}
            </Grid>
        </>
    );
};
